// frontend/src/api/dutyOperatorsApi.ts
// Версия: 1.0.0 (2026-09-10)
// Клиент реестра оперативных дежурных: GET /api/admin/settings/duty-operators (таблица duty_operators)

import { apiUrl } from '../config/paths';
import { Operator } from '../constants/operators.const';

export interface DutyOperatorRecord {
  id: number;
  code: string;
  fullName: string;
  shortName: string;
  email: string | null;
  isActive: boolean;
  sortOrder: number;
  updatedAt: string | null;
}

export interface DutyOperatorsResponse {
  operators: DutyOperatorRecord[];
  version: string;
}

const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/** Приведение записи реестра к типу Operator (id = code) */
export const toOperator = (record: DutyOperatorRecord): Operator => ({
  id: record.code,
  fullName: record.fullName,
  shortName: record.shortName,
  email: record.email || '',
});

export async function fetchDutyOperators(includeInactive = false): Promise<DutyOperatorsResponse> {
  const query = includeInactive ? '?all=1' : '';
  const response = await fetch(apiUrl(`/admin/settings/duty-operators${query}`), {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error(`duty-operators: HTTP ${response.status}`);
  }
  return response.json();
}
